import { api } from "@src/utils/axios-instance";
import { useMutation } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router";
import toast from "react-hot-toast";
import { useUserStore } from "@src/stores/userStore";
import { useEffect } from "react";

const ConfirmEmail = () => {
    const { token } = useParams();
    const navigate = useNavigate()
    const { logout } = useUserStore()
    async function checkEmailToken() {
        return await api.get("/users/update_email/" + token);
    }
    const query = useMutation({
        mutationFn: async () => {
            const promise = checkEmailToken();
            toast.promise(promise, {
                loading: "Verifying your e-mail, please hold...",
                success: "Your e-mail has been verified! You need to sign back in.",
                error: "Your e-mail could not be verified, please try again."
            });
        },
        retry: false,
    });
    useEffect(() => {
        query.mutate()
        if (query.isSuccess) {
            logout();
            navigate("/login");
        }
    }, [query.isSuccess])
    return (<div> Verifying your e-mail...</div>);
};
export default ConfirmEmail;
